import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import Createpackingslip from './Createpackingslip'
import { useLocation } from "react-router-dom";

const Create = () => {
    const location = useLocation();
  const deliveryNoteId = location.state?.deliveryNoteId;
  return (

    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				<title>Packing Slip - Create</title>
			</Helmet>

      <Header />
      <div className="container-fluid maindiv d-flex flex-column " style={{flexGrow:'1'}}>
        <Createpackingslip deliveryNoteId={deliveryNoteId}/>
      </div>
      </div>
  );
};

export default Create;